export default __webpack_public_path__ + "static/media/mitch.bb32c3ea.jpg";